import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'
import PromotionSpotlightStyles from 'components/common/PromotionSpotlight/PromotionSpotlightStyles'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'


const ScrollablePromotionBannerSpotlight = ({
  items = [],
  onClick,
  isResourcesPage
}) =>
  <>
    <Wrapper>
      {
        items.map((item, index) =>
          <PromoItem key={ item.id || index } content={ item.data } />)
      }
    </Wrapper>
    {isResourcesPage && (
      <ApptBtnWrapper>
        <AppointmentButton full="mobile" narrow onClick={ onClick }>
          <AppointmentIcon asset="book-appointment-white" />
          Request Appointment
          <ArrowIcon asset="arrow-right-white-secondary" />
        </AppointmentButton>
      </ApptBtnWrapper>

    )}
  </>


ScrollablePromotionBannerSpotlight.propTypes = {
  isResourcesPage: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape()),
  onClick: PropTypes.func
}

export default ScrollablePromotionBannerSpotlight

const Wrapper = styled.div`
  margin: 0 auto;
  text-align: center;
  ${Mixin.responsive('padding', '50px 0 0', '30px 0 0')}
`

const PromoItem = styled(HTMLContainer)`
  width: 312px;
  text-align: left;
  ${PromotionSpotlightStyles}
  ${Mixin.responsive('display', 'inline-block', 'block')}
  ${Mixin.responsive('margin', '30px 12px', '30px auto')}
`

const AppointmentButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 20px 8px;
  margin: 30px auto 0;
  width: 335px;
  height: 46px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  ${Media.mobile`
    justify-content: space-around;
  `}
`

const AppointmentIcon = styled(Icon)`
  width: 30px;
  ${Media.mobile`
    width: 20px;
  `}
`

const ArrowIcon = styled(Icon)`
  width: 10px;
  ${Media.mobile`
    width: 7px;
  `}
`

const ApptBtnWrapper = styled.div`
  ${Media.mobile`
    padding: 0 16px;
  `}
`
